module.exports = __webpack_public_path__ + "static/img/Group 7919.07351ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/Group 7919.svg
// module id = Xxvt
// module chunks = 1